import { Box, Grid } from '@material-ui/core';
import { useHttp } from 'hooks/http';
import { IPaginate } from 'interfaces';
import React, {
  useCallback, useEffect, useState,
} from 'react';
import { GoChecklist } from 'react-icons/go';
import { useQuery } from 'react-query';
import HeaderFilterPlus from '../../components/Headers/FilterPlus';
import Layout from '../../components/Layout';
import Pagination from '../../components/Pagination';
import Card from './Card';
import { Container } from './styles';
import { useHistory } from 'react-router-dom';

interface IFilter {
  search?: string;
}

const SocialActionList: React.FC = () => {
  const { httpGet } = useHttp();
  const history = useHistory();
  const [socialActions, setSocialActions] = useState([]);
  const [filter, setFilter] = useState<IFilter>({} as IFilter);
  const [paginate, setPaginate] = useState<IPaginate>({
    page: 1, perPage: 10, lastPage: 1, total: 0,
  });

  const fetchSocialActions = useCallback(async () => {
    const response = await httpGet('social-action', {
      params: {
        filter,
        ...paginate,
      },
    });
    return response.data;

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter, paginate?.page]);

  const { data, status } = useQuery(['socialActions', paginate, filter], fetchSocialActions, {
    refetchOnWindowFocus: false, refetchInterval: 10000, retry: false,
  });

  useEffect(() => {
    if (status === 'success') {
      setSocialActions(data?.data);
      setPaginate(data?.pagination);
    }
  }, [data, status, filter]);

  const handleSearch = (value: string): void => {
    setPaginate({ ...paginate, page: 1 });
    setFilter({ search: value });
  };

  const handlePaginate = (payload: IPaginate): void => {
    setPaginate(payload);
  };

  const breadcrumbs = {
    icon: GoChecklist,
    links: [{ path: '', title: 'Lista de Ações Sociais' }],
  }; 


  return (
    <Layout breadcrumbs={breadcrumbs}>
      <Container>
        <HeaderFilterPlus handleSearch={handleSearch} handlePlus={() => history.push('/social-action')}/>
        <Grid container spacing={3} justify="space-between">
          <Box p={2}><b>Total</b></Box>
          <Box p={2}><b>{socialActions?.length}</b></Box>
        </Grid>

        {socialActions?.map((socialAction: any) => (
          <Card socialAction={socialAction} key={socialAction?.id} />
        ))}

        <Pagination paginate={paginate} handlePaginate={handlePaginate} />
 
        
      </Container>
    </Layout>
  );
};

export default SocialActionList;
